module.exports = __webpack_public_path__ + "img/download.82d26a18.png";